<template>
  <vs-popup classContent="popup-example"  title="ویرایش اطلاعات گارانتی" :active.sync="showPopup">
    <div class="vx-col w-full mb-base" @keydown.enter="updateWarrantyInfo()">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="نام خریدار (sms)"
            v-model="editWarranty.name"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-phone"
            icon-no-border
            label-placeholder="موبایل (sms)"
            v-model="editWarranty.phone_number"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="نام خریدار/مجموعه"
            v-model="editWarranty.customer"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="شماره گارانتی"
            v-model="editWarranty.number"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="نوع سیستم"
            v-model="editWarranty.system_type"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder">
              <div class="vs-con-input">
                  <pdatepicker
                      :placeholder="editWarranty.start_date"
                      header-background-color="#fb8103"
                      hover-day-back-color="#fb8103"
                      chosen-day-back-color="#fb8103"
                      class="vs-inputx vs-input--input hasValue hasIcon"
                      style="border : 1px solid rgba(0, 0, 0, 0.2)"
                      v-model="editWarranty.start_date"
                  ></pdatepicker>
                  <!-- <span class="input-span-placeholder vs-input--placeholder normal normal vs-placeholder-label">
                      تاریخ تولد
                  </span> -->
                  <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-calendar null icon-no-border"></i>
              </div>
              <span></span>
          </div>
        </div>

        <div class="vx-col w-full mt-4">
          <label class="vs-input--label">آدرس</label>
          <vs-textarea v-model="editWarranty.address" rows="4" />
        </div>

      </div>

      <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
        <vs-col class="sm:w-1/2 w-full">

        </vs-col>
        <vs-col class="sm:w-1/2 w-full">
          <vs-button class="mr-3 float-right" @click="updateWarrantyInfo()" :disabled="!validateForm">ثبت</vs-button>
        </vs-col>
      </vs-row>

    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'EditWarranty',

  props: {
    popupEditWarranty: {
        type: Boolean,
        default: false,
    },
    warrantyId: Number
  },

  components: {},

  computed: {
    validateForm() {
      return this.editWarranty.customer != '' && this.editWarranty.number != '' && this.editWarranty.system_type != '' && this.editWarranty.start_date != '' && this.editWarranty.address != '';
    },
  },

  data() {
    return {
      showPopup: false,
      editWarranty: {
        customer: '',
        number: '',
        system_type: '',
        start_date: '',
        address: '',
        name: '',
        phone_number: ''
      },
    }
  },

  watch: {
    popupEditWarranty(newVal) {
      this.showPopup = newVal
      if(newVal == true){
        this.$vs.loading()
        this.$store.dispatch('getWarrantyInfo', this.warrantyId)
        .then(res => {
          this.editWarranty = res.data[0]
          this.$vs.loading.close()
        }).catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: '',
            text: 'خطا در اتصال به اینترنت',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
      }
    },

    showPopup(newVal) {
      this.$emit('updatePopupEditWarranty', newVal)
      this.editWarranty = {
        customer: '',
        number: '',
        system_type: '',
        address: '',
        start_date: '',
        name: '',
        phone_number: '',
        }
    },
  },

  created(){
  },

  methods: {
    updateWarrantyInfo(){
      let start_date = ''
      if(this.editWarranty.start_date != '') {
        start_date = this.editWarranty.start_date.replaceAll('/','-')
      }
      let warrenty = {
        id: this.warrantyId,
        customer : this.editWarranty.customer,
        number : this.editWarranty.number,
        system_type : this.editWarranty.system_type,
        address : this.editWarranty.address,
        start_date: start_date,
        name: this.editWarranty.name,
        phone_number: this.editWarranty.phone_number
      }
      this.editWarranty = {
        customer: '',
        number: '',
        system_type: '',
        address: '',
        start_date: '',
        name: '',
        phone_number: '',
      }
      this.$vs.loading()
      this.$emit('updatePopupEditWarranty', false)
    this.$store.dispatch('updateWarrantyInfo', warrenty)
    .then(() => {
      this.$vs.loading.close()
      this.$vs.notify({
        title: '',
        text: 'اطلاعات گارانتی با موفقیت ویرایش شد.',
        iconPack: 'feather',
        icon: 'icon-check-square',
        color: 'success'
      })
    })
    .catch(() => {
      this.$vs.loading.close()
      this.$vs.notify({
      title: '',
      text: 'اطلاعات وارد شده صحیح نمی باشد.',
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'warning'
      })
    })
  },
  }
}
</script>

